/*
 * @Date: 2025-04-27 23:18:16
 * @LastEditors: lifangdi
 * @LastEditTime: 2025-11-04 17:21:27
 */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ScrollProvider } from "./hooks/useScrollContext";
import { initRem } from "./utils/setRem";
initRem();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ScrollProvider>
      <App />
    </ScrollProvider>
  </React.StrictMode>
);
